import { StyleSheet } from 'react-native';

import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  flex: {
    flex: 1,
  },
  marginBetweenComponents: {
    marginTop: 32,
  },
  paymentInfoContainer: {
    marginTop: 25,
  },
  containerStyle: withSubHeaderSubTitle => ({
    marginTop: withSubHeaderSubTitle ? 20 : 0,
    paddingBottom: 160,
  }),
  billBreakDownText: theme => ({
    fontSize: 24,
    color: theme.colors.textColorThree,
    ...Fonts.type.bold,
  }),
  cardStyle: theme => ({
    padding: 16,
    marginTop: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: Colors.blackThree,
    shadowOffset: { width: 0, height: 3 },
    shadowOpacity: 0.16,
    shadowRadius: 8,
    elevation: 4,
  }),
  billPriceStyle: {
    color: Colors.dark_grey,
  },
  subHeaderAfterSubTitle: {
    marginLeft: 6,
  },
  subHeaderDescriptionStyle: isLoading => ({
    marginTop: isLoading ? 0 : 4,
  }),
  subHeaderFullContainerStyle: {
    marginLeft: 2,
    marginTop: 15,
  },
  scrollViewContentContainerStyle: {
    paddingBottom: 260,
  },
  line: {
    borderBottomWidth: 1,
    borderBottomColor: Colors.veryLightPink,
    marginVertical: 30,
  },
  errorPreviousBillsIconStyle: {
    marginTop: 16.6,
  },
  errorPreviousBillsBackgroundStyle: {
    height: 250,
  },
  headerLoaderStyle: {
    width: 150,
  },
  descriptionInfoLoaderStyle: {
    width: 60,
  },
  subHeaderSubtitleLoaderStyle: {
    width: 60,
  },
  negativeBalanceText: theme => ({
    fontSize: 16.6,
    marginRight: 7,
    color: theme.colors.showMoreColor,
  }),
  icon: {
    margin: 4,
  },
});
